import { atom, selector, useRecoilState, useSetRecoilState } from 'recoil';
import { useContext, useEffect } from 'react';
import { DataContext } from 'entries/common/widgets/context';
import { TTintServiceState } from '../types/tint-service-state.type';
import { TTintColor } from '../types/tint-color.type';

const DEFAULT_STATE: TTintServiceState = {
  isTintServiceAvailable: false,
  selectedColor: null,
};

export const tintServiceState = atom({
  key: 'tintService',
  default: DEFAULT_STATE,
});

export const tintServiceIsAnyColorsSelected = selector({
  key: 'tintServiceIsAnyColorsSelected',
  get: ({ get }) => {
    const { selectedColor } = get(tintServiceState);
    return selectedColor !== null;
  },
});

export const useTintServiceState = () => {
  const [tintState, setTintState] = useRecoilState(tintServiceState);

  const { isTintServiceAvailable, selectedColor } = tintState;

  const setSelectedTintColor = (newSelectedColor: TTintColor) => {
    setTintState(prev => ({ ...prev, selectedColor: newSelectedColor }));
  };

  const setIsTintServiceAvailable = (isAvailable: boolean) => {
    setTintState(prev => ({ ...prev, isTintServiceAvailable: isAvailable }));
  };

  const deleteColorFromSelected = () => {
    setTintState(prev => ({ ...prev, selectedColor: null }));
  };

  return {
    isTintServiceAvailable,
    setIsTintServiceAvailable,
    selectedColor,
    setSelectedTintColor,
    deleteColorFromSelected,
  };
};

export const useInitTintServiceState = () => {
  const data = useContext(DataContext);
  const setTintState = useSetRecoilState(tintServiceState);

  useEffect(() => {
    if (data?.isTintAvailable) {
      const isTintParamsExists =
        Boolean(data?.collectionName) || Boolean(data?.colorName) || Boolean(data?.hex);

      setTintState({
        isTintServiceAvailable: data?.isTintAvailable,
        selectedColor: isTintParamsExists
          ? {
              COLLECTION_NAME: data?.collectionName ?? undefined,
              COLOR_NAME: data?.colorName ?? '',
              HEX: data?.hex ?? '',
            }
          : null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Нужно послать только один раз
  }, []);
};
